module.exports = __webpack_public_path__ + "static/the-coming-of-the-french-revolution-98115eab4b1bd85ff8d50b6c5021c344.jpg";